import {
  BOIType, IDocumentType,
  IEntity, IEntityDocument,
  IEntityProgressMap,
  IEntitySubmitConsent,
  IEntityTotalProgress,
  UUID,
} from "src/app/core/interfaces";
import {
  IShareTypeChanges
} from "../../modules/entities/components/cap-table/components/configure-share-types-dialog/configure-share-types-dialog.component";
import {
  IShareRecordChanges
} from "../../modules/entities/components/cap-table/components/configure-share-records-dialog/configure-share-records-dialog.component";

export namespace SecureFile {
  export class Reset {
    static readonly type = "[SecureFile] Reset";
  }

  export class GetEntity {
    static readonly type = "[SecureFile] Get Entity";
    constructor(public entityId: UUID) { }
  }
  export class GetEntitySuccess {
    static readonly type = "[SecureFile] Get Entity Success";
    constructor(public entity: IEntity) { }
  }
  export class GetEntityFail {
    static readonly type = "[SecureFile] Get Entity Fail";
    constructor(public error: unknown) { }
  }

  export class GetEntities {
    static readonly type = "[SecureFile] Get Entities";
  }
  export class GetEntitiesSuccess {
    static readonly type = "[SecureFile] Get Entities Success";
    constructor(public entities: IEntity[]) { }
  }
  export class GetEntitiesFail {
    static readonly type = "[SecureFile] Get Entities Fail";
    constructor(public error: unknown) { }
  }

  export class Create {
    static readonly type = "[SecureFile] Create Entity";
    constructor(public entity: IEntity) { }
  }
  export class CreateSuccess {
    static readonly type = "[SecureFile] Create Entity Success";
    constructor(public entity: IEntity) { }
  }
  export class CreateFail {
    static readonly type = "[SecureFile] Create Entity Fail";
    constructor(public error: unknown) { }
  }

  export class Update {
    static readonly type = "[SecureFile] Update Entity";
    constructor(public entity: IEntity) { }
  }
  export class UpdateSuccess {
    static readonly type = "[SecureFile] Update Entity Success";
    constructor(public updatedEntity: IEntity, public message = "Entity updated") { }
  }
  export class UpdateFail {
    static readonly type = "[SecureFile] Update Entity Fail";
    constructor(public error: unknown) { }
  }

  export class AddOwnerToEntity {
    static readonly type = "[SecureFile] Add Owner To Entity";
    constructor(
      public entityId: UUID,
      public ownerId: UUID,
      public boiType: BOIType
    ) { }
  }
  export class AddOwnerToEntitySuccess {
    static readonly type = "[SecureFile] Add Owner To Entity Success";
    constructor(public entity: IEntity) { }
  }
  export class AddOwnerToEntityFail {
    static readonly type = "[SecureFile] Add Owner To Entity Fail";
    constructor(public error: unknown) { }
  }

  export class RemoveOwnerFromEntity {
    static readonly type = "[SecureFile] Remove Owner From Entity";
    constructor(
      public entityId: UUID,
      public ownerId: UUID,
      public boiType: BOIType
    ) { }
  }
  export class RemoveOwnerFromEntitySuccess {
    static readonly type = "[SecureFile] Remove Owner From Entity Success";
    constructor(public entity: IEntity) { }
  }
  export class RemoveOwnerFromEntityFail {
    static readonly type = "[SecureFile] Remove Owner From Entity Fail";
    constructor(public error: unknown) { }
  }

  export class GetTotalEntityProgress {
    static readonly type = "[SecureFile] Get Total Entity Progress";
    constructor(
      public entityId: UUID,
      public ownerEntityIds: UUID[] = [],
      public isNeedUpdateEntityInFirestore = true
    ) { }
  }
  export class GetTotalEntityProgressSuccess {
    static readonly type = "[SecureFile] Get Total Entity Progress Success";
    constructor(
      public entityId: UUID,
      public totalProgress: IEntityTotalProgress,
      public ownerEntityProgressMap: IEntityProgressMap = {}
    ) { }
  }
  export class GetTotalEntityProgressFail {
    static readonly type = "[SecureFile] Get Total Entity Progress Fail";
    constructor(public error: unknown) { }
  }

  export class Delete {
    static readonly type = "[SecureFile] Delete Entity";
    constructor(public entityId: UUID) { }
  }
  export class DeleteSuccess {
    static readonly type = "[SecureFile] Delete Entity Success";
    constructor(public entityId: UUID) { }
  }
  export class DeleteFail {
    static readonly type = "[SecureFile] Delete Entity Fail";
    constructor(public error: unknown) { }
  }

  export class SubmitToFinCEN {
    static readonly type = "[SecureFile] Submit To FinCEN";
    constructor(
      public entityId: UUID,
      public consentData: IEntitySubmitConsent
    ) { }
  }
  export class SubmitToFinCENSuccess {
    static readonly type = "[SecureFile] Submit To FinCEN Success";
  }
  export class SubmitToFinCENFail {
    static readonly type = "[SecureFile] Submit To FinCEN Fail";
    constructor(public error: unknown) { }
  }


  export class UpdateCapTable {
    static readonly type = "[SecureFile] Update Capitalization Table";
    constructor(public entityId: UUID,  public shareTypeChanges: IShareTypeChanges) { }
  }

  export class ManageCapTableRecords {
    static readonly type = "[SecureFile] Manage Capitalization Table Records";
    constructor(
      public entityId: UUID,
      public shareTypeId: UUID,
      public shareRecordChanges: IShareRecordChanges,
    ) { }
  }

  export class UpdateDocumentTypes {
    static readonly type = "[SecureFile] Update Document Types";
    constructor(
      public entityId: UUID,
      public updatedDocTypes: IDocumentType[]
    ) { }
  }

  export class AddDocumentsToType {
    static readonly type = "[SecureFile] Add Documents To Type";
    constructor(
      public entityId: UUID,
      public documentTypeId: UUID,
      public documents: IEntityDocument[],
    ) { }
  }

  export class MoveDocumentBetweenTypes {
    static readonly type = "[SecureFile] Move Document Between Types";
    constructor(
      public entityId: UUID,
      public fromDocumentTypeId: UUID,
      public toDocumentTypeId: UUID,
      public documentId: UUID,
    ) { }
  }

  export class RemoveDocumentFromType {
    static readonly type = "[SecureFile] Remove Document From Type";
    constructor(
      public entityId: UUID,
      public documentTypeId: UUID,
      public document: IEntityDocument,
    ) { }
  }
}
